module.exports = __webpack_public_path__ + "static/media/medias.3cc3a4d0.jpg";